import { useContext } from 'react';
import FeatureToggleContext from './FeatureToggleContext';

const useFeatureToggle = () => {
  return useContext(FeatureToggleContext);
};

export default useFeatureToggle;
